// src/app/reducers/form.ts
interface FormState {
  payer: any | null;
  recipient: any | null;
  formType: string | null;
  taxYears: string | null;
  formDetails: any;
  necForm: any;
  miscForm: any;
  fromSubmitData: any;
  submittedForms: any;
  submitPayer: any;
  saveForm: any;
  w8Recipient: any | null;
  w9Recipient: any | null;
  totalFormCount: number;
  submittedFormCount: number;
  billingAddress: any | null;
}

const initialState: FormState = {
  payer: null,
  recipient: null,
  formType: null,
  taxYears: null,
  formDetails: null,
  necForm: {},
  miscForm: {},
  saveForm: {},
  fromSubmitData: {},
  submitPayer: {},
  w8Recipient: [],
  w9Recipient: [],
  submittedForms: [],
  totalFormCount: 0,
  submittedFormCount: 1,
  billingAddress: {}
};

const formReducer = (state = initialState, action: any): FormState => {
  switch (action.type) {
    case 'SET_PAYER':
      return { ...state, payer: action.payload };
    case 'SET_RECIPIENT':
      return { ...state, recipient: action.payload };
    case 'SET_FORMTYPE':
      return { ...state, formType: action.payload };
    case 'SET_TAXYEARS':
      return { ...state, taxYears: action.payload };
    case 'SET_FORM':
      return { ...state, formDetails: action.payload };
    case 'SET_ITEM_FORM':
      return {
        ...state,
        formDetails: { ...state.formDetails, ...action.payload },
      };
    case 'SET_NEC':
      return { ...state, necForm: action.payload };
    case 'SET_ITEM_NEC':
      return {
        ...state,
        necForm: { ...state.necForm, ...action.payload },
      };
    case 'SET_MISC':
      return { ...state, miscForm: action.payload };
    case 'SET_ITEM_MISC':
      return {
        ...state,
        miscForm: { ...state.miscForm, ...action.payload },
      };
    case 'SET_FROM_SUBMIT_DATA':
      return { ...state, fromSubmitData: action.payload };
    case 'SET_SUBMIT_PAYER':
      return { ...state, submitPayer: action.payload };
    case 'SET_SAVE_FORM':
      return {
        ...state,
        saveForm: action.payload,
      };
    case 'SET_W8_RECIPIENT':
      return {
        ...state,
        w8Recipient: [...state.w8Recipient, action.payload],
      };

    case 'SET_W9_RECIPIENT':
      return {
        ...state,
        w9Recipient: [...state.w9Recipient, action.payload],
      };
    case 'CLEAR_W9_W8_RECIPIENT':
      return {
        ...state,
        w9Recipient: [],
        w8Recipient: [],
      };
    case 'SET_SUBMITTED_FORMS':
      return {
        ...state,
        submittedForms: [action.payload, ...state.submittedForms],
      };
    case 'SET_TOTAL_FORM_COUNT':
      return {
        ...state,
        totalFormCount: action.payload,
        submittedFormCount: 1,
      };
    case 'SET_INCREMENT_SUBMITTED_FORM_COUNT':
      return { ...state, submittedFormCount: state.submittedFormCount + 1 };

    case 'SET_BILLING_ADDRESS':
      return { ...state, billingAddress: action.payload };

    case 'CLEAR_ALL_FORM_DATA':
      return {
        ...state,
        necForm: {},
        miscForm: {},
        saveForm: {},
        fromSubmitData: {},
        submitPayer: {},
        w9Recipient: [],
        w8Recipient: [],
        submittedForms: [],
      };
    default:
      return state;
  }
};

export default formReducer;
